import {ChangeDetectionStrategy, Component, HostBinding, inject, Input, input, OnInit} from '@angular/core';
import {StoryblokStylingService} from '@core/services/storyblok-styling.service';

import {DynamicModule} from 'ng-dynamic-component';
import {NgOptimizedImage} from '@angular/common';
import {StoryblokComponentService} from '@core/services/storyblok-component.service';
import {StoryblokDynamicInputService} from '@core/services/storyblok-dynamic-input.service';
import {ReadMoreComponent} from '@layout/components/general/read-more/read-more.component';
import {StoryblokReadMoreComponent} from '@modules/storyblok/components/storyblok-read-more.component';
import {ReplaceImgPipe} from '@core/pipes/replace-img.pipe';
import {SafeHtmlPipe} from '@core/pipes/safe-html.pipe';

@Component({
  selector: 'app-storyblok-image-description',
  templateUrl: './storyblok-image-description.component.html',
  styleUrls: ['./storyblok-image-description.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DynamicModule, ReadMoreComponent, ReplaceImgPipe, SafeHtmlPipe, NgOptimizedImage]
})
export class StoryblokImageDescriptionComponent extends StoryblokReadMoreComponent implements OnInit {
  protected storyblokComponentService = inject(StoryblokComponentService);
  private storyblokStylingService = inject(StoryblokStylingService);
  private storyblokDynamicInputService = inject(StoryblokDynamicInputService);

  components: any = this.storyblokComponentService.getComponents();

  background_color = input<string>();

  general_styling = input<any>();
  image = input<any>();
  description = input<string>();
  title = input<string>();
  icon = input<any>();
  useReadMore = input<boolean>(false);

  @Input()
  set elementId(value: any) {
    this.hostElementId = value;
  }

  constructor() {
    super();
  }

  @HostBinding('attr.id') hostElementId: any;
  @HostBinding('class') class: any;

  @HostBinding('style.background-color')
  get backgroundColor() {
    return this.storyblokDynamicInputService.replaceDynamicInputs(this.background_color() ?? '', true)();
  };

  ngOnInit() {
    this.class = this.storyblokStylingService.getClassList(this.general_styling());
  }
}
